import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=b4d377e0&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.scss?vue&type=style&index=0&id=b4d377e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d377e0",
  null
  
)

export default component.exports